import { render, staticRenderFns } from "./InvestorMerchantContractV20260318.vue?vue&type=template&id=1e9f2f0f&scoped=true&"
import script from "./InvestorMerchantContractV20260318.vue?vue&type=script&lang=js&"
export * from "./InvestorMerchantContractV20260318.vue?vue&type=script&lang=js&"
import style0 from "./InvestorMerchantContractV20260318.vue?vue&type=style&index=0&id=1e9f2f0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9f2f0f",
  null
  
)

export default component.exports